module.exports = __webpack_public_path__ + "static/media/lese-is-wrong.79dde574.mp3";